/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Row, Col } from "react-awesome-styled-grid";
import { Link } from "react-router-dom";
import { Box, SVGIcon, Text, theme, Tooltip } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { ButtonChevron } from "~/components/CollapseItem/CollapseItem";
import { ROUTES } from "~/routing/routes";

type GeneralServiceButtonProps = {
  generalEnvId: string;
  customerId: string;
};
export function GeneralServiceButton({
  generalEnvId,
  customerId,
}: GeneralServiceButtonProps) {
  return (
    <Box
      boxStyle="lightGrey"
      backgroundColor={theme.color.background.ui03}
      spacing="spacing02"
    >
      <Row>
        <Col sm={8} md={8} lg={12}>
          <Link
            to={`${ROUTES.customers.index}/${customerId}/general-customer-service/${generalEnvId}`}
          >
            <FlexContainer grow align="center">
              <ButtonChevron name="storage" isChildren isExpanded={false} />
              <Text
                size="lg"
                weight="medium"
                tag="div"
                color={theme.color.interactive.link}
              >
                General customer services with SLA mapping
              </Text>
              <Tooltip
                status="notification"
                caption="Attaching services and SLA here means all those are assigned at the entire customer level (independent environment or app) and can be mapped further at environment/app level for the further split purpose"
              >
                <FlexContainer css={{ marginLeft: ".25rem" }}>
                  <SVGIcon size="sm" name="info" aria-label="info" />
                </FlexContainer>
              </Tooltip>
            </FlexContainer>
          </Link>
        </Col>
      </Row>
    </Box>
  );
}
